export default "__VITE_ASSET__BErFfbJK__"